import type { ThemeInfo } from './presentation';

// Web availability is independent of the shared artwork catalog and mobile progress.
export const AVAILABLE_THEME_IDS = ['jelly', '07-crystal', 'fruit'] as const;
// Applies to numerals painted over skin previews, never score/record values.
export function showsSkinNumber(id: string): boolean {
  return !id || id === 'jelly' || id === '07-crystal';
}
export function availableThemes(catalog: ThemeInfo[]): ThemeInfo[] {
  return AVAILABLE_THEME_IDS.map(id => catalog.find(theme => theme.id === id))
    .filter((theme): theme is ThemeInfo => !!theme);
}
